<div class="error-container" role="alert" aria-live="polite" aria-atomic="true">
    @for (error of errors$ | async; track error.id) {
    <div class="error-toast" [ngClass]="'error-toast--' + error.type">
        <div class="error-toast__icon">
            {{ getIcon(error.type) }}
        </div>
        <div class="error-toast__content">
            <h4 class="error-toast__title">{{ error.title }}</h4>
            <p class="error-toast__message">{{ error.message }}</p>
            @if (error.retryable) {
            <p class="error-toast__hint">💡 Tip: Click "Retry" to try again</p>
            }
        </div>
        <div class="error-toast__actions">
            @if (error.retryable) {
            <button class="error-toast__action error-toast__retry" (click)="retry(error.id)"
                [attr.aria-label]="'Retry ' + error.title" title="Retry">
                🔄
            </button>
            }
            @if (error.dismissible) {
            <button class="error-toast__action error-toast__close" (click)="dismiss(error.id)"
                [attr.aria-label]="'Dismiss ' + error.title" title="Dismiss">
                ✕
            </button>
            }
        </div>
    </div>
    }
</div>